import React from 'react';
import { Layout } from 'antd';
import Navbar from '../../../components/layout/navbar/Navbar';
import SupplierSidebar from '../../../components/layout/sidebar/SupplierSidebar';
import { Outlet } from 'react-router-dom';
import Breadcrumb from '../../../components/common/breadcrumb/Breadcrumb';

const { Content } = Layout;

function DashboardOutlet() {
  return (
    <div>
      <Layout>
        <Navbar />
        <Layout>
          <SupplierSidebar />
          <Content className="bg-[#EAF5FF]">
            <Breadcrumb />   
            <Outlet /> 
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default DashboardOutlet;
